module.exports = "/packs/images/Company.png";